// Redux
import { useSelector, useDispatch } from 'react-redux';
import {
  setShowRoundDrawer,
  setSelectedRound,
} from '@Modal/reducers/rounds/drawer/rubberDuckRoundDrawerSlice';
// System
import { useSnackbar } from 'notistack';
// Graphql
import { useRubberDuckRoundLazyQuery } from '@Src/generated.graphql';
// Types
import { AppDispatch } from 'src/app/store';
import { StoreInterface } from 'src/app/types';

export const useRubberDuckRoundDrawer = () => {
  const [getRound] = useRubberDuckRoundLazyQuery();
  const dispatch = useDispatch<AppDispatch>();

  const { showRoundDrawer, selectedRoundData } = useSelector(
    (state: StoreInterface) => state?.rubberDuckRoundDrawer
  );

  const { enqueueSnackbar } = useSnackbar();

  const handleRoundRowClick = async (id: string) => {
    try {
      const { data } = await getRound({ variables: { roundId: id } });
      if (data) {
        await dispatch(setSelectedRound(data?.rubberDuckRound));
        dispatch(setShowRoundDrawer(true));
      }
    } catch (error) {
      enqueueSnackbar(error, {
        autoHideDuration: 2000,
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
        },
      });
    }
  };

  return {
    // Store
    showRoundDrawer,
    selectedRoundData,
    // Actions
    setSelectedRound,
    setShowRoundDrawer,
    // Handlers
    handleRoundRowClick,
  };
};
